<template>
    <div v-resize="onResize" v-if="!(!loading && data.length === 0)">
        <h2>Two candidate preferred by vote type</h2>
        <br/>
        <loader v-if="loading" />
        <v-data-table v-if="!loading" :headers="headers"                    
                    :items="data"
                    :disable-initial-sort="true"
                    :hide-headers="isMobile"
                    :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
                    hide-actions>

            <template v-slot:items="props">
                <tr v-if="isMobile">
                    <td>
                        <div class="flex-content">
                            <div class="flex-item pt-2">
                                <h3 class="pb-xs-0">
                                    <span v-if="!props.item.Phid">{{ props.item.Candidate }}</span>
                                    <router-link v-if="props.item.Phid" :to="{ name: 'Parliamentarian', params: { PHID: props.item.Phid } }">
                                        {{ props.item.Candidate }}
                                    </router-link>
                                </h3>
                            </div>
                            <div class="flex-item flex-item-col" data-label="Party">
                                <span v-if="!props.item.PartyLinked || props.item.Status != 'Elected'">{{ props.item.Party }}</span>
                                <router-link v-if="props.item.PartyLinked && props.item.Status == 'Elected'" :to="{ name: 'Party', params: { Party: props.item.PartyLinked }}">
                                    {{ props.item.PartyLinkedName }}
                                </router-link>
                            </div>
                            <div class="flex-item flex-item-col" v-if="props.item.Status != '' " data-label="Status">
                                {{ props.item.Status }}
                            </div>
                            <div class="flex-item flex-item-col" v-if="props.item.Status == ''" >
                                <!-- Leave empty -->
                            </div>
                            <div class="flex-item flex-item-col flex-item-col-50" data-label="Ordinary">
                                {{ props.item.OrdinaryVotes }} ({{ props.item.OrdinaryVotesPercentage }}%)
                            </div>
                            <div class="flex-item flex-item-col flex-item-col-50" data-label="Absent">
                                {{ props.item.AbsentVotes }} ({{ props.item.AbsentVotesPercentage }}%)
                            </div>
                            <div class="flex-item flex-item-col flex-item-col-50" data-label="Provisional">
                                {{ props.item.ProvisionalVotes }} ({{ props.item.ProvisionalVotesPercentage }}%)
                            </div>
                            <div class="flex-item flex-item-col flex-item-col-50" data-label="Declaration pre-poll">
                                {{ props.item.PrePollVotes }} ({{ props.item.PrePollVotesPercentage }}%)
                            </div>
                            <div class="flex-item flex-item-col flex-item-col-50" data-label="Postal">
                                {{ props.item.PostalVotes }} ({{ props.item.PostalVotesPercentage }}% )
                            </div>
                            <div class="flex-item flex-item-col flex-item-col-50" data-label="Total">
                                {{ props.item.TotalVotes }} ({{ props.item.TotalVotesPercentage }}%)
                            </div>
                        </div>
                    </td>
                </tr>
                <tr v-else>
                    <td class="text-xs-left">
                        <span v-if="!props.item.Phid">{{ props.item.Candidate }}</span>
                        <router-link v-if="props.item.Phid" :to="{ name: 'Parliamentarian', params: { PHID: props.item.Phid } }">
                            {{ props.item.Candidate }}
                        </router-link>
                    </td>
                    <td class="text-xs-left">
                        <span v-if="!props.item.PartyLinked || props.item.Status != 'Elected'">{{ props.item.Party }}</span>
                        <router-link v-if="props.item.PartyLinked && props.item.Status == 'Elected'" :to="{ name: 'Party', params: { Party: props.item.PartyLinked }}">
                            {{ props.item.PartyLinkedName }}
                        </router-link>
                    </td>
                    <td class="text-xs-left">{{ props.item.OrdinaryVotes }}</td>
                    <td class="text-xs-left">{{ props.item.OrdinaryVotesPercentage }}</td>
                    <td class="text-xs-left">{{ props.item.AbsentVotes }}</td>
                    <td class="text-xs-left">{{ props.item.AbsentVotesPercentage }}</td>
                    <td class="text-xs-left">{{ props.item.ProvisionalVotes }}</td>
                    <td class="text-xs-left">{{ props.item.ProvisionalVotesPercentage }}</td>
                    <td class="text-xs-left">{{ props.item.PrePollVotes }}</td>
                    <td class="text-xs-left">{{ props.item.PrePollVotesPercentage }}</td>
                    <td class="text-xs-left">{{ props.item.PostalVotes }}</td>
                    <td class="text-xs-left">{{ props.item.PostalVotesPercentage }}</td>
                    <td class="text-xs-left">{{ props.item.TotalVotes }}</td> 
                    <td class="text-xs-left">{{ props.item.TotalVotesPercentage }}</td>
                    <td class="text-xs-left">{{ props.item.Status }}</td>
                </tr>
            </template>
        </v-data-table>           
    </div>
</template>
<script>
import Loader from '@/components/Loader.vue';
import axios from 'axios';
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {
    props: ['division', 'year'],
    components: {
        Loader
    },
    created() {
        this.initialiseData();
    },
    mounted() {
        this.onResize();
    },
    data() {
        return {
            data: [],
            isMobile: false,
            loading: true,
            headers: [{
                text: 'Candidate',
                value: 'Candidate'
            },
            {
                text: 'Party',
                value: 'Party'
            },
            {
                text: 'Ordinary',
                value: 'OrdinaryVotes'
            },
            {
                text: '%',
                value: 'OrdinaryVotesPercentage'
            },            
            {
                text: 'Absent',
                value: 'AbsentVotes'
            },
            {
                text: '%',
                value: 'AbsentVotesPercentage'
            },            
            {
                text: 'Provisional',
                value: 'ProvisionalVotes'
            },
            {
                text: '%',
                value: 'ProvisionalVotesPercentage'
            },            
            {
                text: 'Declaration pre-poll',
                value: 'PrePollVotes'
            },
            {
                text: '%',
                value: 'PrePollVotesPercentage'
            },            
            {
                text: 'Postal',
                value: 'PostalVotes'
            },      
            {
                text: '%',
                value: 'PostalVotesPercentage'
            },                                
            {
                text: 'Total',
                value: 'TotalVotes'
            },     
            {
                text: '%',
                value: 'TotalVotesPercentage'
            },                              
            {
                text: 'Status',
                value: 'Status'
            }]
        }
    },
    methods: {
        initialiseData: function () {
            this.loading = true;
            const url = `Elections/TwoCandidatePreferredByVoteType?divisionName=${this.division}&year=${this.year}`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.data = response.data;
                    this.loading = false;
                });
        },
        onResize() {
            if (window.innerWidth < 769){
                this.isMobile = true;
            }
            else{
                this.isMobile = false;
            }
        },
    }
}

</script>